import { api } from '@cwd/lib/main';

export interface PendingDeviceSummary {
    TrustedDeviceId: string;
    UserId: string;
    UserEmail: string;
    UserName: string;
    UserLanguageId: string;
    UserAgent: string;
    CreatedAt: string;
    CodeExpiresAt: string | null;
}

export async function approveDevice(trustedDeviceId: string): Promise<void> {
    return api.post(`/BackOffice/TrustedDevices/${trustedDeviceId}/Approve`, null);
}

export async function getPendingDevicesForUser(userId: string): Promise<PendingDeviceSummary[]> {
    return api.get(`/BackOffice/TrustedDevices/Pending/ByUser/${userId}`);
}
